module.exports = "<!-- <emi-header-banner></emi-header-banner> -->\r\n <br>\r\n <br>\r\n <br>\r\n<div class=\"col-md-12\">\r\n    <app-dynamic-products></app-dynamic-products>\r\n</div>\r\n\r\n\r\n<div class=\"col-md-12\">\r\n    <app-bank-rate-calculation></app-bank-rate-calculation>\r\n</div> \r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/calculators/home-loan-comparison-calculator/bank-comparison-side-menu/bank-comparison-side-menu.component.html
// module id = 683
// module chunks = 8